import * as QA from 'shared/utils/queryAnalysis';
import * as Simple from './simpleConverters';
import { getPicklistConverter } from './picklistConverter';

export { NamesConverter } from './namesConverter';
export * from './simpleConverters';
export * from './picklistConverter'


export function getExcelValuesConverter(field) {
  if (QA.isPicklistField(field)) { return getPicklistConverter(field); }
  if (QA.isNumberField(field)) { return Simple.ensureNumberConverter.bind(null, field.type); }

  switch (field.type) {
    case QA.FieldTypeName.Date: return Simple.dateConverter;
    case QA.FieldTypeName.DateTime: return Simple.dateTimeConverter;
    case QA.FieldTypeName.Time: return Simple.timeConverter;
    default: return Simple.bypassConverter;
  }
}

